<template>
  <div class="container">
    <Header></Header>
    <UserForm v-on:userFilled="save($event)"></UserForm>
    <Footer></Footer>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import UserForm from '@/components/UserForm.vue'
import { User } from '../entities/User'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

@Component({
  components: {
    UserForm,
    Header,
    Footer
  }
})
export default class UserNew extends Vue {
  save (user:User) {
    this.$store.commit('saveUser', user)
  }
}
</script>

<style scoped>

</style>
